<header id="page-topbar">
  <div class="navbar-header">
    <div id="menuIcon" class="d-flex">
      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>
    <div *ngIf="!tokenExpired && showInfo">
      <countdown
        style="color: gray"
        [config]="{ leftTime: timeToExpired }"
      ></countdown>
    </div>
    <div *ngIf="tokenExpired">
      <span class="text-danger">Token Expirado</span>
    </div>
    <ng-container *ngIf="!isProd || isLocalhost"
      ><div class="card bg-warning" style="margin: auto; align-self: center">
        Development
      </div>
    </ng-container>
    <i
      class="fa fa-home ms-4"
      aria-hidden="true"
      href="#"
      (click)="routeToInfoPage()"
      style="margin-left: auto; align-self: center; cursor: pointer"
    ></i>

    <!-- <ng-container *ngIf="showInfo">
      <div
        (click)="routeToInfoPage()"
        class="d-block"
        style="margin-left: auto; align-self: start"
      >
        <div class="card">
          <div class="d-flex justify-content-between">
            <div>Gateway</div>
            <div
              class="card m-0"
              id="statusProd"
              style="width: 20px; height: 20px"
            ></div>
          </div>
        </div>
      </div>
    </ng-container> -->

    <div id="menuUser" class="d-flex">
      <!-- <div *ngIf="!tokenExpired">
        <countdown [config]="{ leftTime: timeToExpired }"></countdown>
      </div>
      <div *ngIf="tokenExpired">
        <span class="text-danger">Token Expirado</span>
      </div> -->

      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item user text-start d-flex align-items-center"
          id="page-header-user-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <img
            class="rounded-circle header-profile-user"
            src="assets/images/r2d2.png"
            alt="Header Avatar"
          />
          <span class="ms-2 d-none d-sm-block user-item-desc">
            <span class="user-name">{{ user!.name }}</span>
          </span>
        </button>
        <div class="dropdown-menu dropdown-menu-end pt-0" ngbDropdownMenu>
          <button
            type="button"
            class="btn header-item user text-start d-flex align-items-center"
            id="page-header-user-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            ngbDropdownToggle
          >
            <img
              class="rounded-circle header-profile-user"
              src="assets/images/r2d2.png"
              alt="Header Avatar"
            />
            <span class="ms-2 d-none d-sm-block user-item-desc">
              <span class="user-name">{{ user!.name }}</span>
            </span>
          </button>
          <a
            class="dropdown-item"
            href="javascript: void(0);"
            (click)="changePassword()"
            ><i
              class="mdi mdi-lock-reset text-muted font-size-16 align-middle me-1"
            ></i>
            <span class="align-middle">Trocar a senha</span></a
          >
          <a
            class="dropdown-item"
            href="javascript: void(0);"
            (click)="logout()"
            ><i
              class="mdi mdi-logout text-muted font-size-16 align-middle me-1"
            ></i>
            <span class="align-middle">Logout</span></a
          >
        </div>
      </div>
    </div>
  </div>
</header>
